<template>
  <v-row>
    <v-col cols="1" />
    <v-col class="mt-n4" cols="10">
      <v-select
        v-model="serviceDetails"
        @change="serviceSelected"
        :items="services"
        item-text="name"
        item-value="details"
        label="Service Name"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import { TimeStampToDate } from "@/common/utilities/date";

export default {
  name: "SelectService",

  props: {
    resetToggle: Boolean
  },

  data: () => ({
    serviceDetails: {},
    services: []
  }),

  mounted() {
    this.option = "After";

    this.$store.dispatch("getServices").then(docs => {
      this.services = [];

      for (const doc of docs) {
        this.services.push({
          name: doc.name,
          details: {
            id: doc.id,
            location: doc.location,
            schedule: TimeStampToDate(doc.schedule),
            serviceName: doc.name
          }
        });
      }
    });
  },

  methods: {
    serviceSelected() {
      this.$emit("setSelectedId", this.serviceDetails || "");
      this.$emit("onSelectedService", this.serviceDetails || {});
    }
  },

  watch: {
    resetToggle() {
      this.serviceDetails = {};
    }
  }
};
</script>
